import React from "react";
import { getSortDirectionIcon } from "./SortDirection";
const SortIcon = _ref => {
  let {
    sortDirection,
    altText
  } = _ref;
  const Icon = getSortDirectionIcon(sortDirection);
  return /*#__PURE__*/React.createElement(Icon, {
    className: "h-full w-full",
    "aria-label": altText
  });
};
export default SortIcon;